import React from "react";
import { Column, ColumnId } from ".";
import base from "./base";
import TransportationTypeCellContent from "../components/TransportationTypeCellContent";

function transportationType({ width, onResize, language }: Column.Options) {
	return base(
		ColumnId.TransportationType,
		(item) => (
			<TransportationTypeCellContent item={item} language={language} />
		),
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default transportationType;
